module.exports = __webpack_public_path__ + "static/media/balloons.9fa53ce5.jpg";